import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '首页', to: '/' },
  { label: '剧集分类', to: '/category' },
  { label: '搜索剧集', to: '/search' },
  { label: '关于我们', to: '/about' },
];

const categoryLinks = ['剧情', '爱情', '家庭', '悬疑', '都市', '古装', '青春', '科幻'];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-secondary-900 text-background-100 md:mt-20">
      <div className="mx-auto grid w-full max-w-[1400px] gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-play-circle-fill text-xl" />
            </span>
            <span className="font-heading text-lg font-semibold text-background-50">妈妈的朋友在线观看</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
            专注热门电视剧的在线观看与剧情资料查询平台，提供高清剧集入口、详细剧情介绍与演员信息，帮助观众快速找到想看的剧集。
          </p>
          <div className="mt-5 flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-800 text-background-200">
              <i className="ri-wechat-line text-lg" />
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-800 text-background-200">
              <i className="ri-weibo-line text-lg" />
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-800 text-background-200">
              <i className="ri-mail-line text-lg" />
            </span>
          </div>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-background-50">快速导航</h4>
          <ul className="mt-4 space-y-3 text-sm text-background-300">
            {quickLinks.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="transition-colors hover:text-accent-300">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-background-50">热门分类</h4>
          <ul className="mt-4 flex flex-wrap gap-2 text-sm">
            {categoryLinks.map((item) => (
              <li key={item}>
                <Link
                  to={`/category?genre=${encodeURIComponent(item)}`}
                  className="inline-block rounded-full bg-secondary-800 px-3 py-1 text-background-200 transition-colors hover:bg-secondary-700"
                >
                  {item}
                </Link>
              </li>
            ))}
          </ul>
          <h4 className="mt-6 font-heading text-sm font-semibold text-background-50">联系方式</h4>
          <p className="mt-3 text-sm text-background-300">
            <i className="ri-mail-send-line mr-2" />
            service@momfilm-example.com
          </p>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="mx-auto flex w-full max-w-[1400px] flex-col gap-2 px-4 py-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>© 2026 妈妈的朋友在线观看 · 本站为影视资讯演示平台，内容均为虚构示例。</p>
          <p>本平台仅提供前端演示，不提供真实视频播放服务。</p>
        </div>
      </div>
    </footer>
  );
}